import React from 'react';
import { useParams } from 'react-router-dom';
import { SxStyle } from '../../../types';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import NetworkConfiguratorForm from './network-configurator-components/network-form';
import firebaseApp from '../../../firebase-app';
import { useDocumentData } from 'react-firebase-hooks/firestore';
import { ParamTypes, IpRangeArenaConfig } from './types';
import { useStringsContext } from '../../../contexts/strings';
import { doc, updateDoc } from 'firebase/firestore';

const styles: SxStyle = {
  root: {
    minWidth: 275,
    padding: '20px',
  },
};

function NetworkConfigurator() {
  const { strings } = useStringsContext();
  const { arena } = useParams<ParamTypes>();

  const firestorePath = `/wifi/sv/ip-ranges/${arena}`;
  const [ipRangeArenaConfig, loading] = useDocumentData(doc(firebaseApp.db, firestorePath));

  const submitConfig = async (config: any) => {
    const docRef = doc(firebaseApp.db, firestorePath);
    await updateDoc(docRef, config);
  };

  if (ipRangeArenaConfig && !loading) {
    return (
      <>
        <Typography paddingLeft={2} paddingBottom={1}>
          {strings.wifi.networkConfigurator}
        </Typography>
        <Paper sx={styles.root}>
          <NetworkConfiguratorForm
            ipRangeArenaConfig={ipRangeArenaConfig as IpRangeArenaConfig}
            submitConfig={submitConfig}
          />
        </Paper>
      </>
    );
  }

  return null;
}

export default NetworkConfigurator;
